import type { FC } from "react";
import type { RequestOrigins, ShiftRequest } from "../../../utils/models";
import MetaChip from "../../UIToolkit/Badges/MetaChip";
import { EventList } from "../../UIToolkit/molecules/EventList";
import { EventListItem } from "../../UIToolkit/molecules/EventListItem";
import { RequestOriginTile } from "./RequestOriginTile";
import { formatAt, kindTitle, leadShort, type OriginCopyContext, sentence, slotPill } from "./requestOriginCopy";

type Props = { request: ShiftRequest; origins: RequestOrigins; copy: OriginCopyContext };

/**
 * Every cause that opened a slot on the request, as the steps of one flow: earliest first, each tile on a rail to the
 * next, the slots it opened on the right, and the step the request stands at now picked out.
 */
export const RequestOriginCauseList: FC<Props> = ({ request, origins, copy }) => {
	const lastIndex = origins.openings.length - 1;
	return (
		<EventList variant="timeline" dataTestId={`request-origin-flow-${request.id}`}>
			{origins.openings.map((opening, index) => (
				<EventListItem
					key={`${opening.kind}-${opening.at.toMillis()}`}
					dataTestId={`request-origin-cause-${request.id}-${index}`}
					emphasis={index === lastIndex}
					leading={<RequestOriginTile opening={opening} />}
					title={kindTitle(opening, copy)}
					text={sentence(opening, request, true, copy)}
					meta={`${formatAt(opening.at, copy)} · ${leadShort(opening.leadMinutes, copy)}`}
					trailing={<MetaChip size="small" tone={index === 0 ? "primary" : "neutral"} label={slotPill(opening, index, copy)} />}
				/>
			))}
		</EventList>
	);
};
